import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "transactions section section--mini" }

import "./WithdrawalsView.scss";
import {computed, onMounted, ref, watch} from "vue";
import WithdrawalEntity from "@/entities/WithdrawalEntity";
import moment from "moment";
import Icon from "@/components/Icon/Icon.vue";
import {useApiStore} from "@/stores/apiStore";
import Withdrawal from "@/components/Withdrawal/Withdrawal.vue";

interface Props{
	orderBy : 'asc' | 'desc'
}


export default /*#__PURE__*/_defineComponent({
  __name: 'WithdrawalsView',
  props: {
    orderBy: { default: 'desc' }
  },
  setup(__props: any) {

let {api} = useApiStore();

let props = __props;

let items = ref<WithdrawalEntity[]>([]);
let loading = ref<boolean>(false);

async function loadWithdrawals(){

	loading.value = true;

	let withdrawals = await api.getWithdrawals(1, 100, {
		mode : props.orderBy,
		field : 'id'
	});

	items.value = withdrawals.items;
	loading.value = false;

}

onMounted(loadWithdrawals);
watch(() => props.orderBy, loadWithdrawals);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items), (item) => {
      return (_openBlock(), _createBlock(Withdrawal, {
        withdrawal: item,
        key: item.id
      }, null, 8, ["withdrawal"]))
    }), 128))
  ]))
}
}

})